import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=c4c65024&"
import script from "./Blacklist.vue?vue&type=script&lang=js&"
export * from "./Blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports